import BaseAction from "./BaseAction";
import SuspiciousActivityReducer from "../reducers/SuspiciousActivityReducer";

class SuspiciousActivityAction extends BaseAction {
  onClose = () => {};

  reset = () => {
    const { machines } = this.data();
    this.dispatch({ ...this.reducer.initialState, machines });
  };

  open = async (data) => await this.dispatch({ ...data, open: true });
}

const action = new SuspiciousActivityAction(SuspiciousActivityReducer);

export default action;
